var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-container"},[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t("welcome"))+" ")]),_c('h2',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.$t("welcome_message"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }